module.exports = __webpack_public_path__ + "static/media/mech-crossed-v2.28847194.png";